import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { Component, ElementRef, ViewChild } from '@angular/core'
import { ModalController } from '@ionic/angular/standalone'
import { PlatformService } from '../services/business/platform.service'
import { CacheService } from '../services/business/cache.service'
import { CRBSettingKeys } from '../services/api/models/configuration.model'

@Component({
    selector: 'html-privacy-policy-modal',
    templateUrl: './html-privacy-policy-modal.component.html',
    styleUrls: ['./html-privacy-policy-modal.component.scss'],
})
export class HtmlPrivacyPolicyModalComponent {
    public modalHtmlUrl = ''
    public safeResourceUrl: SafeResourceUrl

    @ViewChild('headerRef', { static: false }) headerRef: ElementRef;

    crbPrivacyNotice: string
    programPrivacyNotice: string
    marketingPartnerPrivacyNotice: string
    privacyPolicyType: PrivacyNoticeType
    crbConfigName: string
    programName: string

    constructor(public platform: PlatformService,
        public modalController: ModalController,
        public cacheService: CacheService,
        public sanitizer: DomSanitizer) {

        setTimeout(() => {
            const settings = this.cacheService.getBrandConfigSettings()

            this.programPrivacyNotice = settings?.documents?.[CRBSettingKeys.ProgramPrivacyPolicy]
            this.crbPrivacyNotice = settings?.documents?.[CRBSettingKeys.CRBPrivacyPolicy]
            this.marketingPartnerPrivacyNotice = settings?.documents?.[CRBSettingKeys.MarketingPartnerPrivacyPolicy]
            this.programName = settings?.content?.[CRBSettingKeys.ProgramName]

            this.showPrivaceNotice(PrivacyNoticeType.SightlinePayments)
            const config = cacheService.getCRBConfig()
            this.crbConfigName = config?.name?.toUpperCase()
        }, 100)
    }

    public async dismiss(): Promise<void> {
        const modal = await this.modalController.getTop()
        if (modal) {
            await modal.dismiss()
        }
    }

    showPrivaceNotice(privaceNotice: PrivacyNoticeType): void {
        if (privaceNotice == PrivacyNoticeType.SightlinePayments) {
            this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://drive.google.com/viewer?embedded=true&hl=en-US&url=${this.programPrivacyNotice}`)
            this.privacyPolicyType = PrivacyNoticeType.SightlinePayments
        } else if (privaceNotice == PrivacyNoticeType.CRB) {
            this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://drive.google.com/viewer?embedded=true&hl=en-US&url=${this.crbPrivacyNotice}`)
            this.privacyPolicyType = PrivacyNoticeType.CRB
        } else if (privaceNotice == PrivacyNoticeType.MarketingPartner) {
            this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://drive.google.com/viewer?embedded=true&hl=en-US&url=${this.marketingPartnerPrivacyNotice}`)
            this.privacyPolicyType = PrivacyNoticeType.MarketingPartner
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const headerHeight = this.headerRef.nativeElement.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }, 100)
    }
}

export enum PrivacyNoticeType {
    SightlinePayments = 1,
    CRB = 2,
    MarketingPartner = 3
}
